// src/components/CollapsibleRound.js
//
// Wraps a round's content in a collapsible section with a header showing
// the round name and a context-specific suffix.
//
// Two modes for the header suffix:
//   - Default: pass `pickedCount` and `totalCount` to render "(N/M picked)".
//     Used by PickSubmission and AdminPickEntry.
//   - Override: pass `headerExtra` (string or React node) to render anything
//     else. Used by AdminGameResults to render "(N remaining)".
//
// The `collapsible` prop controls whether the toggle button renders.
// PickSubmission uses collapsible=false for single-round groups (e.g. an
// individual Round 3 group in a Round-by-Round pool, where there's nothing
// to collapse alongside). AdminPickEntry and AdminGameResults always use
// collapsible=true.

import React from 'react';

function CollapsibleRound({
    round,
    pickedCount,
    totalCount,
    headerExtra,
    isCollapsed,
    onToggle,
    collapsible = true,
    children
}) {
    const suffix = headerExtra !== undefined
        ? headerExtra
        : `(${pickedCount}/${totalCount} picked)`;

    return (
        <div className="mb-4">
            {collapsible && (
                <button
                    onClick={onToggle}
                    className="w-full flex items-center justify-between px-4 py-3 bg-gray-900 border border-gray-800 rounded-xl mb-3 hover:border-gray-600 transition-colors">
                    <span className="text-sm font-black text-gray-400 uppercase tracking-wide">
                        {round.round_name}
                        <span className="ml-2 text-xs text-gray-600 normal-case font-normal">
                            {suffix}
                        </span>
                    </span>
                    <span className="text-gray-500 text-sm">{isCollapsed ? '▶' : '▼'}</span>
                </button>
            )}
            {!isCollapsed && children}
        </div>
    );
}

export default CollapsibleRound;